import { useState, useEffect } from 'react';
import { useNavigate } from '@shopify/app-bridge-react';
import { useStore } from '@/hooks';
import axios from '@/lib/axios';

const RedirectToSubscription = ({ children }) => {
  const navigate = useNavigate();
  const { store } = useStore();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (!store) return;

    const { appInstallation: plan } = store;

    if (
      store.isTrial ||
      plan.partnerDevelopment ||
      plan.subscription ||
      store.isBeta
      // || (store.isBeta && !plan.usageBasedSubscription)
    ) {
      setChecked(true);
      return;
    }

    const fetchSubscription = async () => {
      const result = await axios.get('/api/shopify/subscription');
      const { subscription, confirmationUrl } = result.data;
      if (subscription) {
        setChecked(true);
        return;
      }

      navigate(confirmationUrl);
    };

    fetchSubscription();
  }, [store]);

  if (!checked) return null;

  return children;
};

export default RedirectToSubscription;
